import { ProductSubTier } from '@sparemin/api-sdk';
import { useSelector } from 'react-redux';
import { isNumber } from 'underscore';
import {
  planEndInDaysSelector,
  seenFreeTrialRemindersSelector,
  subtierSelector,
} from 'redux/modules/pricing';
import { FreeTrialReminder } from 'redux/modules/pricing/types';

interface UseFreeTrialReminderConfig {
  prevSubtier: ProductSubTier;
}

type UseFreeTrialReminderReturnType = FreeTrialReminder | false;

export default function useFreeTrialReminder({
  prevSubtier,
}: UseFreeTrialReminderConfig): UseFreeTrialReminderReturnType {
  const subtier = useSelector(subtierSelector);
  const planEndInDays = useSelector(planEndInDaysSelector);
  const seenFreeTrialReminders = useSelector(seenFreeTrialRemindersSelector);

  return !seenFreeTrialReminders.includes(FreeTrialReminder.LAST_WEEK) &&
    subtier === ProductSubTier.PRO_TRIAL &&
    isNumber(planEndInDays) &&
    planEndInDays < 7
    ? FreeTrialReminder.LAST_WEEK
    : prevSubtier === ProductSubTier.PRO_TRIAL &&
      subtier === ProductSubTier.FREE
    ? FreeTrialReminder.OVER
    : false;
}
